module.exports = __webpack_public_path__ + "static/media/plan-mas-gb-libre.83623bac.svg";